import type { NavigationFailure, RouteLocationRaw } from 'vue-router'

import { useTabs } from '@vben/hooks'
import { preferences } from '@vben/preferences'
import { isPlainObject } from '@vben/utils'

import { isNumber, isString } from 'lodash-es'

import { app } from '#/bootstrap'
import { getMicroApp, getMicroAppBaseRoute, isInMicroApp } from '#/micro-app'

import { router as _router } from './'

export interface GoOptions {
  isReplace?: boolean
  closeTab?: boolean
}

export async function go(
  location?: number | RouteLocationRaw,
  { isReplace = false, closeTab = false }: GoOptions = {},
): Promise<NavigationFailure | undefined> {
  app?.runWithContext(async () => {
    const router = isInMicroApp() ? getMicroApp().router : _router
    const { closeCurrentTab } = useTabs()
    location ??= preferences.app.defaultHomePath
    if (isNumber(location)) {
      return router.go(location)
    }
    if (closeTab) {
      closeCurrentTab()
    }
    const action = isReplace ? router.replace : router.push
    try {
      if (isInMicroApp()) {
        if (isString(location)) {
          location =
            getMicroAppBaseRoute() +
            (location.startsWith('/') ? location.slice(1) : location)
          console.log(location)
        } else if (isPlainObject(location) && location.path) {
          location.path =
            getMicroAppBaseRoute() +
            (location.path.startsWith('/')
              ? location.path.slice(1)
              : location.path)
          console.log(location.path)
        }
      }
      return await action(location)
    } catch (error: any) {
      console.log(error)
      throw error
    }
  })
}
